module.exports = __webpack_public_path__ + "static/media/unboxing shell na caixa.577bae43.png";